// extracted by mini-css-extract-plugin
export default {"reason":"DenyDispute_reason__hSxXq"};